import { enableProdMode, isDevMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import {
  RouteReuseStrategy,
  provideRouter,
  withPreloading,
  PreloadAllModules,
} from '@angular/router';
import {
  IonicRouteStrategy,
  provideIonicAngular,
} from '@ionic/angular/standalone';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { KycService } from './app/services/kyc.service';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { IonicService } from './app/services/ionic.service';
import { ModalController } from '@ionic/angular';
import { AuthService } from './app/services/auth.service';
import { UserService } from './app/services/user.service';
import { RequestInterceptor } from './app/core/guards/request.interceptor';
import { LoadingInterceptor } from './app/core/guards/loading.interceptor';
import { provideTransloco } from '@ngneat/transloco';
import { TranslocoHttpLoader } from './app/transloco-root.module';
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEsAr from '@angular/common/locales/es-AR';
import { LoadingService } from './app/services/loading.service';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { provideAnimations } from '@angular/platform-browser/animations';

//This is necessary for the thousands separator to be a "."
registerLocaleData(localeEsAr, 'es-AR');

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
    provideIonicAngular(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    KycService,
    BrowserModule,
    IonicService,
    LoadingService,
    ModalController,
    provideHttpClient(withInterceptorsFromDi()),
    AuthService,
    UserService,
    provideTransloco({
      config: {
        availableLangs: ['en', 'es'],
        defaultLang: 'es',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    { provide: LOCALE_ID, useValue: 'es-AR' },
    // Providers para el datepicker
    provideAnimations(),
    importProvidersFrom(NgxDaterangepickerMd.forRoot())
  ],
});
